import React, { useState } from 'react';
import styled from 'styled-components';

// Styled components for PostcodeCheck
const PostcodeContainer = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  max-width: 100%;
`;

const Heading = styled.h3`
  margin-bottom: 15px;
  color: #333;
`;

const InputGroup = styled.div`
  display: flex;
  margin-bottom: 15px;
`;

const Input = styled.input`
  flex-grow: 1;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px 0 0 5px;
`;

const Button = styled.button`
  background-color: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  
  &:hover {
    background-color: #218838;
  }
`;

const CheckResult = styled.p`
  margin-top: 10px;
  color: ${({ isEligible }) => (isEligible ? '#28a745' : '#dc3545')};
`;

const PostcodeCheck = () => {
  const [postcode, setPostcode] = useState('');
  const [checkResult, setCheckResult] = useState('');
  const [isEligible, setIsEligible] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getCookie = (name) => {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.substring(0, name.length + 1) === (name + '=')) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  };

  const checkPostcode = async () => {
    setIsLoading(true);
    setCheckResult('');
    setIsEligible(null);
    try {
      const csrftoken = getCookie('csrftoken');
      const headers = {
        'Content-Type': 'application/json',
        ...(csrftoken ? { 'X-CSRFToken': csrftoken } : {}),
      };

      const response = await fetch('/api/check-postcode/', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ postcode }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      const { is_eligible, delivery_days } = data;
      
      setIsEligible(is_eligible);
      if (is_eligible) {
        setCheckResult(`We deliver to your area on: ${delivery_days.join(', ')}`);
      } else {
        setCheckResult("Sorry, we don't currently deliver to your area.");
      }
    } catch (error) {
      console.error('Error checking postcode:', error);
      setCheckResult('An error occurred while checking your postcode. Please try again.');
      setIsEligible(null);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PostcodeContainer>
      <Heading>Check Delivery Eligibility</Heading>
      <InputGroup>
        <Input
          type="text"
          value={postcode}
          onChange={(e) => setPostcode(e.target.value)}
          placeholder="Enter your postcode"
        />
        <Button onClick={checkPostcode} disabled={isLoading}>
          {isLoading ? 'Checking...' : 'Check'}
        </Button>
      </InputGroup>
      {checkResult && (
        <CheckResult isEligible={isEligible}>
          {checkResult}
        </CheckResult>
      )}
    </PostcodeContainer>
  );
};

export default PostcodeCheck;